import {
  Collapse,
  Dialog,
  DialogContent,
  DialogTitle,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Box,
} from "@mui/material";
import ActionButton from "../../Base/views/ActionButton";
import { Link } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";
import SettingsSuggestIcon from "@mui/icons-material/SettingsSuggest";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { useSelector } from "react-redux";
import { grey } from "@mui/material/colors";
import FinanceMenu from "./FinanceMenu";
import AtsMenu from "./AtsMenu";
import LmsMenu from "./LmsMenu";
import EmployeeMenu from "./EmployeeMenu";
import MyFinanceMenu from "./MyFinanceMenu";
import { checkPayrollAccess, isAdminOwner } from "../../Base/helper/baseFunctions";
import VisitorsManagementMenu from "./VisitorsManagementMenu";
import ExpenseManagementMenu from "./ExpenseManagementMenu";
import ECMSMenu from "./ECMSMenu";
import CanteenManagementMenu from "./CanteenManagementMenu";
import AuthorizationMenu from "./AuthorizationMenu";

const MobileMenu = ({
  settingsAccess,
  open,
  close,
  sideBarData1,
  sideBarData2,
  handleMenuClick,
  selectedMenu,
  isMobile,
  theme,
  userData,
  financeCollapse,
  setFinanceCollapse,
  payrollOptions,
  access,
  atsCollapse,
  setAtsCollapse,
  atsOptions,
  atsSubMenu,
  atsManageCollapse,
  setAtsManageCollapse,
  atsReportCollapse,
  setReportCollapse,
  atsReportMenu,
  lmsCollapse,
  setLmsCollapse,
  lmsSubMenu,
  EmployeeCollapse,
  setEmployeeCollapse,
  employeeOptions,
  myfinanceCollapse,
  handleMyFinanceCollapse,
  myFinanceSubMenu,
  collapse,
  setCollapse,
  visitorsCollapse, 
  handleVisitorsCollapse, 
  visitorsManagementSubMenu,
  expenseCollapse,
  handleExpenseCollapse,
  expenseManagementSubMenu,
  sideFNFData,
  canteenCollapse,
  handleCanteenCollapse,
  canteenManagementSubMenu,
  sideAuthorizationData
}) => {
  const { atsModuleData } = useSelector(
    (state) => state?.RoleAndAccessReducer?.ATSModuleReducer
  );
  const ATSAccess = atsModuleData?.find((item) => item.module_name === "ATS");
  const atsDashboarAccess = atsModuleData?.find(
    (item) => item.module_name === "ATS Dashboard"
  );
  const leaveAccess = atsModuleData?.find(    // workspace level identifier
    (item) => item.module_name === "Leave"
  );
  const leaveUserAccess = atsModuleData?.find(   // user level identifier, but always check workspace level identifier first
    (item) => item.module_name === "LMS User"
  );
  const myEmployeeAccess = atsModuleData?.find(
    (item) => item.module_name === "My Employee"
  );
  const payrollAccess = atsModuleData?.find(
    (item) => item.module_name === "Payroll"
  );
  const FNFAccess = atsModuleData?.some(
    (item) => item.module_name === "FNF"
  );
  const CanteenAccess = atsModuleData?.some(
    (item) => item.module_name === "Canteen Management"
  );
  const lmsExecutiveAccess = userData?.core_hr_user_type === "Employee" && atsModuleData?.some(
    (item) => item.module_name === "LMS Executive"
  );
  const ExternalUserCoreHr = atsModuleData?.some(
    (item) => item.module_name === "External User CoreHr"
  );
  const AuthorizationManagementAccess = atsModuleData?.find((item) => item.module_name === "Authorization Management");

  const payrollExecutiveAccess = checkPayrollAccess();
  const visitorsManagementAccess = userData?.workspace_visitor_management_flag && userData?.enable_visitor_management && userData?.f_country_code === "IND"
  const expenseManagementAccess = userData?.workspace_expense_flag && userData?.f_country_code === "IND" ;
  return (
    <Dialog
      sx={{
        ".MuiDialog-paper": {
          maxWidth: "330px",
          borderRadius: "10px",
          marginTop: "2.5rem",
          marginBottom: "10px",
        },
      }}
      open={open}
      fullScreen
      maxWidth="xs"
      classes={{
        paper: {
          padding: "2px",
          position: "absolute",
          top: "5px",
        },
      }}
    >
      <DialogTitle
        sx={{
          justifyContent: "flex-end",
          display: "flex",
          padding: "0px",
          paddingTop: "5px",
        }}
      >
        <ActionButton
          disableHover={false}
          onClick={() => {
            close(false);
          }}
        >
          <CloseIcon color="action" />
        </ActionButton>
      </DialogTitle>
      <DialogContent sx={{ padding: "0px", height: "100vh" }}>
        <List
          sx={{
            padding: "3px",
            overflowY: "scroll",
            maxHeight: collapse ? "50%" : "80%",
            height: collapse ? "50%" : "80%",
            "&::-webkit-scrollbar": {
              width: "8px",
            },
            "&::-webkit-scrollbar-track": {
              background: "#f1f1f1",
              borderRadius: "10px",
            },
            "&::-webkit-scrollbar-thumb": {
              background: "#c1c1c1",
              borderRadius: "10px",
            },
            "&::-webkit-scrollbar-thumb:hover": {
              background: "#a8a8a8",
            },
            scrollbarWidth: "thin",
            scrollbarColor: "#c1c1c1 #f1f1f1",
          }}
        >
          {sideBarData1.map((res, id) => {
            return (
              <Link
                key={id}
                to={res?.route}
                style={{
                  color: theme.palette.mode === "dark" ? "white" : "black",
                }}
              >
                {res?.show && (
                  <ListItem
                    disablePadding
                    sx={{ display: "block", fontSize: "12px", marginLeft: 0 }}
                    onClick={(e) => handleMenuClick(res?.label, res?.route)}
                    className={
                      selectedMenu === res?.label ? "mobile-gradiant" : ""
                    }
                  >
                    <ListItemButton
                      sx={{
                        borderRadius: "8px",
                        minHeight: 48,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "flex-start",
                        gap: 2,
                        padding: "8px 12px",
                        transition: "all 0.3s ease",
                      }}
                    >
                      <ListItemIcon
                        sx={{
                          minWidth: 0,
                          width: "24px",
                          height: "24px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          "& svg": {
                            fontSize: "20px",
                          },
                        }}
                      >
                        <span
                          style={{
                            color:
                              selectedMenu === res?.label
                                ? "white"
                                : theme.palette.mode === "dark"
                                ? theme.palette.text.primary
                                : theme.palette.text.secondary,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          {res?.icon}
                        </span>
                      </ListItemIcon>
                      <ListItemText
                        primary={res?.label}
                        primaryTypographyProps={{
                          variant: "body2",
                          fontWeight: selectedMenu === res?.label ? 600 : 500,
                          fontSize: "0.85rem",
                        }}
                        sx={{ margin: 0 }}
                      />
                    </ListItemButton>
                  </ListItem>
                )}
              </Link>
            );
          })}

          {leaveAccess && (leaveUserAccess || lmsExecutiveAccess) && userData?.f_country_code === "IND" && (
            <LmsMenu
              lmsCollapse={lmsCollapse}
              setLmsCollapse={setLmsCollapse}
              open={open}
              lmsSubMenu={lmsSubMenu}
              selectedMenu={selectedMenu}
              handleMenuClick={handleMenuClick}
              isMobile={isMobile}
              theme={theme}
            />
          )}
          {payrollAccess && !ExternalUserCoreHr && userData?.f_country_code === "IND" && (
            <MyFinanceMenu
              myfinanceCollapse={myfinanceCollapse}
              setMYFinanceCollapse={handleMyFinanceCollapse}
              open={open}
              myFinanceSubMenu={myFinanceSubMenu}
              selectedMenu={selectedMenu}
              handleMenuClick={handleMenuClick}
              isMobile={isMobile}
              theme={theme}
            />
          )}
          {myEmployeeAccess && (
            <EmployeeMenu
              EmployeeCollapse={EmployeeCollapse}
              setEmployeeCollapse={setEmployeeCollapse}
              open={open}
              employeeOptions={employeeOptions}
              selectedMenu={selectedMenu}
              handleMenuClick={handleMenuClick}
              isMobile={isMobile}
              theme={theme}
            />
          )}
           {AuthorizationManagementAccess && (
            <AuthorizationMenu
              open={open}
              selectedMenu={selectedMenu}
              handleMenuClick={handleMenuClick}
              isMobile={isMobile}
              theme={theme}
              sideAuthorizationData={sideAuthorizationData}
            />
            )}
          
          {/* Finance Menu */}
          {payrollExecutiveAccess && (
            <FinanceMenu
              financeCollapse={financeCollapse}
              setFinanceCollapse={setFinanceCollapse}
              open={open}
              payrollOptions={payrollOptions}
              selectedMenu={selectedMenu}
              handleMenuClick={handleMenuClick}
              isMobile={isMobile}
              theme={theme}
            />
          )}
          {/* // expense management */}
            { expenseManagementAccess && !(ExternalUserCoreHr && !userData?.enable_expense_executive) &&  (
              <ExpenseManagementMenu
                expenseCollapse={expenseCollapse}
                handleExpenseCollapse={handleExpenseCollapse}
                open={open}
                expenseManagementSubMenu={expenseManagementSubMenu}
                selectedMenu={selectedMenu}
                handleMenuClick={handleMenuClick}
                isMobile={isMobile}
                theme={theme}
              />
            )}
          {/* VisitorsManagement */}
          {visitorsManagementAccess && (
              <VisitorsManagementMenu
                visitorsCollapse={visitorsCollapse}
                handleVisitorsCollapse={handleVisitorsCollapse}
                open={open}
                visitorsManagementSubMenu={visitorsManagementSubMenu}
                selectedMenu={selectedMenu}
                handleMenuClick={handleMenuClick}
                isMobile={isMobile}
                theme={theme}
              />
            )}
            {/* CanteenManagement */}
          {CanteenAccess && isAdminOwner() && (
              <CanteenManagementMenu
                canteenCollapse={canteenCollapse}
                handleCanteenCollapse={handleCanteenCollapse}
                canteenManagementSubMenu={canteenManagementSubMenu}
                open={open}
                selectedMenu={selectedMenu}
                handleMenuClick={handleMenuClick}
                isMobile={isMobile}
                theme={theme}
              />
            )}
            {FNFAccess && !ExternalUserCoreHr && userData?.f_country_code === "IND" && (
            <ECMSMenu
              open={open}
              selectedMenu={selectedMenu}
              handleMenuClick={handleMenuClick}
              isMobile={isMobile}
              theme={theme}
              sideFNFData={sideFNFData}
            />

          )}
          {/* ATS Menu */}
          {atsDashboarAccess && ATSAccess && userData?.enable_ats && userData?.enable_ats_user && (
            <AtsMenu
              atsCollapse={atsCollapse}
              setAtsCollapse={setAtsCollapse}
              open={open}
              sideBarData={atsOptions}
              userData={userData}
              selectedMenu={selectedMenu}
              handleMenuClick={handleMenuClick}
              theme={theme}
              isMobile={isMobile}
              atsSubMenu={atsSubMenu}
              setAtsManageCollapse={setAtsManageCollapse}
              atsManageCollapse={atsManageCollapse}
              atsReportCollapse={atsReportCollapse}
              setReportCollapse={setReportCollapse}
              atsReportMenu={atsReportMenu}
            />
          )}
        </List>
        {/* Settings Menu - Always visible at bottom */}
        <List
          sx={{ position: "fixed", bottom: 0, width: "330px", padding: "3px" }}
        >
          {settingsAccess && !collapse && (
            <ListItem
              disablePadding
              sx={{ display: "block", fontSize: "12px" }}
            >
              <ListItemButton
                sx={{
                  "&.Mui-selected": {
                    backgroundColor: theme?.palette?.primary?.main + "20",
                  },
                  borderRadius: "8px",
                  minHeight: 48,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-start",
                  gap: 2,
                  padding: "8px 12px",
                  transition: "all 0.3s ease",
                }}
                onClick={() => {
                  !collapse && atsCollapse && setAtsCollapse();
                  setCollapse(!collapse);
                }}
                disableRipple
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "24px",
                    height: "24px",
                  }}
                >
                  <span
                    style={{
                      color:
                        theme.palette.mode === "dark"
                          ? theme.palette.text.primary
                          : theme.palette.text.secondary,
                      transition: "color 0.3s ease",
                    }}
                  >
                    <SettingsSuggestIcon />
                  </span>
                </Box>
                <ListItemText
                  primaryTypographyProps={{
                    variant: "body2",
                    fontWeight: 550,
                    fontSize: "0.8rem",
                    color: grey[600],
                  }}
                  primary="Settings"
                  sx={{ margin: 0 }}
                />
                {collapse ? <ExpandMore /> : <ExpandLess />}
              </ListItemButton>
            </ListItem>
          )}
        </List>

        {/* Settings Collapse Content */}
        <Collapse
          in={collapse}
          timeout="auto"
          unmountOnExit
          sx={{ position: "fixed", bottom: 0, width: "330px" }}
        >
          {/* Settings Header when expanded */}
          <ListItem disablePadding sx={{ display: "block", fontSize: "12px" }}>
            <ListItemButton
              onClick={() => setCollapse(false)}
              sx={{
                backgroundColor: sideBarData2.some(
                  (item) => selectedMenu === item.label
                )
                  ? theme?.palette?.primary?.main + "20"
                  : "transparent",
                borderRadius: "8px",
                minHeight: 48,
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-start",
                gap: 2,
                padding: "8px 12px",
                transition: "all 0.3s ease",
              }}
            >
              <ListItemIcon sx={{ minWidth: "35px" }}>
                <span
                  style={{
                    color: sideBarData2.some(
                      (item) => selectedMenu === item.label
                    )
                      ? theme?.palette?.primary?.main
                      : theme.palette.mode === "dark"
                      ? theme.palette.text.primary
                      : theme.palette.text.secondary,
                    transition: "color 0.3s ease",
                  }}
                >
                  <SettingsSuggestIcon />
                </span>
              </ListItemIcon>
              <ListItemText
                primaryTypographyProps={{
                  variant: "body2",
                  fontWeight: sideBarData2.some(
                    (item) => selectedMenu === item.label
                  )
                    ? 600
                    : 550,
                  fontSize: "0.85rem",
                  color: sideBarData2.some(
                    (item) => selectedMenu === item.label
                  )
                    ? "primary"
                    : grey[600],
                }}
                primary="Settings"
                sx={{ margin: 0 }}
              />
              <ExpandMore />
            </ListItemButton>
          </ListItem>

          {/* Settings Submenu Items */}
          <List sx={{ padding: "3px" }}>
            {sideBarData2.map((res, id) => {
              return (
                <Link
                  key={id}
                  to={res?.route}
                  style={{
                    color: theme.palette.mode === "dark" ? "white" : "black",
                    textDecoration: "none",
                  }}
                >
                  {res?.show && (
                    <ListItem
                      disablePadding
                      sx={{ display: "block", fontSize: "12px" }}
                      onClick={() => handleMenuClick(res?.label, res?.route)}
                    >
                      <ListItemButton
                        selected={selectedMenu === res?.label}
                        sx={{
                          "&.Mui-selected": {
                            backgroundColor:
                              theme?.palette?.primary?.main + "20",
                          },
                          borderRadius: "8px",
                          minHeight: 48,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "flex-start",
                          gap: 2,
                          padding: "8px 12px",
                          transition: "all 0.3s ease",
                        }}
                      >
                        <ListItemIcon
                          sx={{
                            minWidth: 0,
                            width: "24px",
                            height: "24px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            "& svg": {
                              fontSize: "20px",
                            },
                          }}
                        >
                          <span
                            style={{
                              color:
                                selectedMenu === res?.label
                                  ? theme?.palette?.primary?.main
                                  : theme.palette.mode === "dark"
                                  ? theme.palette.text.primary
                                  : theme.palette.text.secondary,
                              transition: "color 0.3s ease",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            {res?.icon}
                          </span>
                        </ListItemIcon>
                        <ListItemText
                          primary={res?.label}
                          primaryTypographyProps={{
                            variant: "body2",
                            fontWeight: selectedMenu === res?.label ? 600 : 500,
                            fontSize: "0.8rem",
                            color:
                              selectedMenu === res?.label
                                ? "primary"
                                : grey[600],
                          }}
                          sx={{ margin: 0 }}
                        />
                      </ListItemButton>
                    </ListItem>
                  )}
                </Link>
              );
            })}
          </List>
        </Collapse>
      </DialogContent>
    </Dialog>
  );
};

export default MobileMenu;
